import React, { createContext, FunctionComponent, ReactNode } from 'react';

export type InternalLink = {
  id?: string;
  href?: string;
};

export type InternalLinkProviderProps = {
  links?: InternalLink[];
  children: ReactNode;
};

export const InternalLinkContext = createContext<InternalLinkProviderProps['links']>([]);

const InternalLinkProvider: FunctionComponent<InternalLinkProviderProps> = (props) => {
  const { links = [], children } = props;

  return <InternalLinkContext.Provider value={links}>{children}</InternalLinkContext.Provider>;
};

export default InternalLinkProvider;
